/** The header compomemt for mobile view. It:
 * renders header for mobile
 * uses a hook for getting title and title styles according to a location path
 * has effect for style changing (shadow under header) while scrolling 
 * 
*/

//react
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

//hooks
import { getHeaderTitle, isWhiteTitlePath, isGreenBackgroundPath, isGrayBackgroundPath } from "../../../utils/getHeaderTitle";

//styles and images
import { HeaderDivMain, Image, MainHeaderIcons, ScreenTitle, NotificationCounter, Div } from "../../../styles/styles";
import notificationIcon from "../../../images/notification-icon.svg";
import accountIcon from '../../../images/account-icon-mobile.svg';
import backIcon from '../../../images/back-icon.svg';

import accountIconGreen from '../../../images/account-icon-green.svg';
import { useTranslation } from "react-i18next";


const HeaderMain = ( { unreadCount, title: titleOverride, gray: forceGray } ) => {

    const location = useLocation();
    const navigate = useNavigate();
    const [scrolled, setScrolled] = useState(false);

    const pathname = location.pathname;
    const isProfile = pathname === '/profile';
    const isEvents = pathname === '/events';
    const isExplore = pathname === '/explore';
    const isArticle = pathname.startsWith('/explore/');

    const { t } = useTranslation("menu");
    const title = titleOverride ?? getHeaderTitle(pathname, t);


    // scroll listening
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 5);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);


    return(        
        <HeaderDivMain green={isGreenBackgroundPath(pathname)} gray={Boolean(forceGray) || isGrayBackgroundPath(pathname) || isArticle} scrolled={scrolled} mobileJustifySpace>

            <MainHeaderIcons width="70px" height="auto" justify='flex-start'>
                {isArticle && 
                 <Image
                    src={backIcon} 
                    onClick={() => navigate(-1)}
                    imgWidth="16px"
                    height="16px"
                />
                }
                
            </MainHeaderIcons>

            <ScreenTitle white={isWhiteTitlePath(pathname)} width="auto">
                {title}
            </ScreenTitle>                                      
            
            <Div row gap="5px" mobileJustifyEnd zIndex="100" mobileWidth="auto">  
                <Image
                    src={isEvents || isExplore || isArticle ? accountIconGreen : accountIcon} 
                    onClick={() => navigate('/account', { state: { returnTo: pathname } })}
                    imgHeight="28px" 
                />
                <MainHeaderIcons>
                    
                    <Image 
                        src={notificationIcon} 
                        onClick={() => navigate('/notifications')}
                        imgHeight="28px" 
                    />
                    {!isProfile && unreadCount > 0 && (
                        <NotificationCounter>
                            {unreadCount > 9 ? "9+" : unreadCount}
                        </NotificationCounter>
                    )}
                </MainHeaderIcons>

            </Div>
            

        </HeaderDivMain>                   
    )
};

export default HeaderMain;
